import { useState, useEffect } from 'react';
import TemplatesService from 'services/TemplatesService';

export default function useTemplatesSearch() {
  const [search, setSearch] = useState('');
  const [results, setResults] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    async function fetchSearch() {
      setIsLoading(true);

      try {
        const { data } = await TemplatesService.search(search);

        setResults(data);
        setIsLoading(false);
      } catch (error) {
        console.log(error.message);
        setIsLoading(false);
      }
    }

    if (!search) {
      setResults(undefined);
      return;
    }

    fetchSearch();
  }, [search]);

  return [setSearch, results, isLoading];
}
